<template>
  <div class="checkin-calendar">
    <div v-if="showCalendar" class="calendar-overlay" @click="closeCalendar"></div>
    <div v-if="showCalendar" ref="calendarPopup" class="calendar-popup">
      <div class="calendar-header">
        <button type="button" class="close-icon" aria-label="关闭" @click="closeCalendar">
          <AppIcon name="close" size="md" aria-label="" />
        </button>
        <div class="calendar-title">
          <h3>签到日历</h3>
          <p v-if="continuousDays > 0">已连续签到{{ continuousDays }}天</p>
          <p v-else>点击今日签到，点击过去日期补签</p>
        </div>
      </div>
      <div class="calendar-controls">
        <button type="button" class="nav-icon" aria-label="上月" @click="prevMonth">
          <AppIcon name="arrowLeft" size="md" aria-label="" />
        </button>
        <span class="current-month">{{ currentYear }}年{{ currentMonth }}月</span>
        <button type="button" class="nav-icon" aria-label="下月" @click="nextMonth">
          <AppIcon name="chevronRight" size="md" aria-label="" />
        </button>
      </div>
      <div class="calendar-grid">
        <div class="calendar-weekdays">
          <div v-for="day in weekdays" :key="day" class="weekday">{{ day }}</div>
        </div>
        <div class="calendar-days">
          <div
            v-for="(day, index) in calendarDays"
            :key="index"
            class="calendar-day"
            :class="{
              'other-month': day.otherMonth,
              today: day.isToday,
              checked: day.checked,
              'can-makeup': canMakeup(day),
            }"
            @click="handleDayClick(day, $event)"
          >
            <span class="day-number">{{ day.date }}</span>
            <AppIcon v-if="day.checked" name="check" size="xs" class="check-icon" aria-label="" />
          </div>
        </div>
      </div>
    </div>
    <Teleport to="body">
      <Transition name="reward-float">
        <div
          v-if="rewardEffect"
          :key="rewardEffect._key"
          class="reward-gold-effect reward-gold-effect-fixed"
          :style="{
            left: rewardEffect.left + 'px',
            top: rewardEffect.top + 'px',
          }"
        >
          +{{ rewardEffect.rewardGold }} 金币
        </div>
      </Transition>
    </Teleport>
  </div>
</template>

<script setup>
import AppIcon from '@/shared/components/AppIcon.vue'
import { useCheckinCalendar } from '@/features/user/composables/useCheckinCalendar'

const props = defineProps({
  showCalendar: {
    type: Boolean,
    default: false,
  },
  continuousDays: {
    type: Number,
    default: 0,
  },
})

const emit = defineEmits(['close', 'checkin-success'])

const {
  currentYear,
  currentMonth,
  weekdays,
  calendarDays,
  rewardEffect,
  prevMonth,
  nextMonth,
  handleDayClick,
  canMakeup,
  closeCalendar,
} = useCheckinCalendar(props, emit)
</script>

<style scoped src="@/features/user/styles/CheckinCalendar.css"></style>
